import OrbitApiV2 from '.'

class CatalogueAPI {
  static getAllProducts(limit = 1000) {
    return OrbitApiV2.httpGet(`/catalog/plans?limit=${limit}`)
  }

  static getOneProduct(productId) {
    return OrbitApiV2.httpGet(`/catalog/plans/getById/${productId}`)
  }
}

export default CatalogueAPI
